import { render, staticRenderFns } from "./StudentViewStudentPermissionsCard.vue?vue&type=template&id=6e500bd5&"
import script from "./StudentViewStudentPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./StudentViewStudentPermissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports